/* ============================================================
   HLP • Apex Landing — behavior (idempotent, delegation-based)
   ============================================================ */
(function () {
  if (window.__hlpApexInit) return;
  window.__hlpApexInit = true;

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function money(cents) {
    var v = (cents / 100);
    return "$" + v.toFixed(2).replace(/\.00$/, "");
  }

  /* ---- Single delegated click handler ---- */
  document.addEventListener("click", function (e) {
    var t = e.target;

    /* Accordions */
    var accHead = closest(t, ".hlp-acc__head, .hlp-faq__head");
    if (accHead) { accHead.parentElement.classList.toggle("is-open"); return; }

    /* Color swatches — set active, update label, swap gallery, update variant */
    var sw = closest(t, ".hlp-swatch");
    if (sw) {
      var group = closest(sw, ".hlp-swatches");
      if (group) {
        group.querySelectorAll(".hlp-swatch").forEach(function (s) { s.classList.remove("is-active"); });
        sw.classList.add("is-active");
        var label = group.getAttribute("data-label-target");
        if (label) { var lbl = document.querySelector(label); if (lbl) lbl.textContent = sw.getAttribute("data-name") || lbl.textContent; }
        var proot = closest(sw, "[data-hlp-product]");
        if (proot) {
          var gal = proot.querySelector("[data-hlp-gallery]");
          if (gal) {
            var nm = sw.getAttribute("data-name");
            gal.querySelectorAll(".hlp-gallery__set").forEach(function (set) {
              var on = set.getAttribute("data-color") === nm;
              set.classList.toggle("is-active", on);
              if (on) set.scrollLeft = 0;
            });
          }
          updateVariant(proot);
        }
      }
      return;
    }

    /* Size / option buttons */
    var size = closest(t, ".hlp-size, .hlp-mini-size");
    if (size) {
      var sgroup = closest(size, ".hlp-sizes, .hlp-bundle__mini");
      if (sgroup) {
        var activeCls = size.classList.contains("hlp-mini-size") ? "hlp-mini-size" : "hlp-size";
        sgroup.querySelectorAll("." + activeCls).forEach(function (s) { s.classList.remove("is-active"); });
        size.classList.add("is-active");
        updateVariant(closest(size, "[data-hlp-product]"));
      }
      return;
    }

    /* Quantity breaks are a visible reference only — not interactive */

    /* Reviews show more / less */
    var moreBtn = closest(t, "[data-hlp-revtoggle]");
    if (moreBtn) {
      var grid = document.querySelector(moreBtn.getAttribute("data-hlp-revtoggle"));
      if (grid) {
        var expanded = grid.classList.toggle("is-expanded");
        moreBtn.textContent = expanded
          ? moreBtn.getAttribute("data-less") || "Show less reviews"
          : moreBtn.getAttribute("data-more") || "Show more reviews";
      }
      return;
    }
  });

  /* ---- Variant matching ---- */
  function updateVariant(root) {
    if (!root) return;
    var dataEl = root.querySelector("[data-hlp-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var selected = [];
    root.querySelectorAll("[data-opt].is-active").forEach(function (b) {
      selected[parseInt(b.getAttribute("data-opt"), 10) - 1] = b.getAttribute("data-val");
    });

    /* Cross out sold-out sizes for the currently selected colour */
    var colorBtn = root.querySelector(".hlp-swatch.is-active[data-opt]");
    var colorPos = colorBtn ? parseInt(colorBtn.getAttribute("data-opt"), 10) : 0;
    var colorVal = colorBtn ? colorBtn.getAttribute("data-val") : null;
    root.querySelectorAll(".hlp-size[data-opt]").forEach(function (btn) {
      var sp = parseInt(btn.getAttribute("data-opt"), 10);
      var sv = btn.getAttribute("data-val");
      var avail = variants.some(function (v) {
        return v.options[sp - 1] === sv && (!colorPos || v.options[colorPos - 1] === colorVal) && v.available;
      });
      btn.classList.toggle("hlp-size--soldout", !avail);
    });

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return selected[i] == null || opt === selected[i]; });
    });
    if (!match) return;

    var idInput = root.querySelector('input[name="id"]');
    if (idInput) idInput.value = match.id;
    var atc = root.querySelector(".hlp-atc");
    if (atc) atc.disabled = !match.available;

    if (!root.hasAttribute("data-hlp-autoprice")) return;
    var nowEl = root.querySelector(".hlp-price__now");
    var wasEl = root.querySelector(".hlp-price__was");
    var saveEl = root.querySelector(".hlp-badge-save");
    var pctEl = root.querySelector(".hlp-badge-pct");
    if (nowEl) nowEl.textContent = money(match.price);
    if (match.compare && match.compare > match.price) {
      if (wasEl) { wasEl.textContent = money(match.compare); wasEl.style.display = ""; }
      if (saveEl) { saveEl.textContent = "Save " + money(match.compare - match.price); saveEl.style.display = ""; }
      if (pctEl) { pctEl.textContent = Math.round((1 - match.price / match.compare) * 100) + "% OFF"; pctEl.style.display = ""; }
    } else {
      if (wasEl) wasEl.style.display = "none";
      if (saveEl) saveEl.style.display = "none";
      if (pctEl) pctEl.style.display = "none";
    }
  }

  /* ---- Add to cart -> open the cart drawer (AJAX) ---- */
  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
  }

  /* Detect the Shopify section ids of the cart drawer / icon so we can
     re-render them with the new item BEFORE opening the drawer. */
  function cartSectionIds(form) {
    var ids = {};
    var sels = [
      "cart-drawer", "cart-drawer-component", "#cart-drawer", "#CartDrawer", ".cart-drawer",
      ".drawer--cart", "[data-cart-drawer]", "#cart-notification", ".cart-notification",
      "#cart-icon-bubble", "[data-cart-count]", ".cart-count-bubble", ".js-cart-count"
    ];
    var custom = form && form.getAttribute("data-drawer");
    if (custom) sels.push(custom);
    sels.forEach(function (sel) {
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (err) { return; }
      nodes.forEach(function (el) {
        var sec = el.closest(".shopify-section");
        if (sec && sec.id && sec.id.indexOf("shopify-section-") === 0) {
          ids[sec.id.replace("shopify-section-", "")] = true;
        }
      });
    });
    return Object.keys(ids);
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest ? e.target.closest(".hlp-form") : null;
    if (!form) return;
    var mode = form.getAttribute("data-after") || "drawer";
    if (mode === "page") return; /* let it submit normally to the cart page */

    e.preventDefault();
    var btn = form.querySelector(".hlp-atc");
    var addUrl = form.getAttribute("action") || (rootUrl() + "cart/add");
    if (!/\.js(\?|$)/.test(addUrl)) addUrl += ".js";
    if (btn) { btn.classList.add("is-loading"); btn.setAttribute("aria-busy", "true"); }

    var body = new FormData(form);
    var ids = cartSectionIds(form);
    if (ids.length) {
      body.append("sections", ids.join(","));
      body.append("sections_url", window.location.pathname);
    }

    fetch(addUrl, {
      method: "POST",
      headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: body
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (item) {
        /* Swap in the freshly-rendered cart sections so the drawer shows the
           new item immediately (no delay). */
        if (item && item.sections) {
          Object.keys(item.sections).forEach(function (id) {
            var sec = document.getElementById("shopify-section-" + id);
            if (sec && typeof item.sections[id] === "string") sec.innerHTML = item.sections[id];
          });
        }
        refreshCartCount();
        var opened = openCartDrawer(form);
        if (btn) { btn.classList.remove("is-loading"); btn.removeAttribute("aria-busy"); }
        if (!opened) showCartToast(item);
      })
      .catch(function () {
        if (btn) { btn.classList.remove("is-loading"); btn.removeAttribute("aria-busy"); }
        form.submit(); /* graceful fallback to the theme's normal add */
      });
  });

  function refreshCartCount() {
    fetch(rootUrl() + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          ".cart-count, [data-cart-count], .cart-count-bubble, .cart-item-count, .header__cart-count, .js-cart-count, #cart-icon-bubble [aria-hidden]"
        ).forEach(function (el) { el.textContent = cart.item_count; });
        try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } })); } catch (err) {}
      })
      .catch(function () {});
  }

  function openCartDrawer(form) {
    /* events many themes listen to (no navigation side-effects) */
    ["cart:refresh", "cart-drawer:open", "cart:open", "cart:toggle", "cart:build"].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (err) {}
    });

    function tryOpen(el) {
      if (!el) return false;
      if (typeof el.open === "function") { try { el.open(); return true; } catch (err) {} }
      if (typeof el.show === "function") { try { el.show(); return true; } catch (err) {} }
      el.classList.add("active", "is-open", "open", "drawer--active", "cart-drawer--active", "is-active");
      el.setAttribute("open", "");
      el.removeAttribute("hidden");
      el.setAttribute("aria-hidden", "false");
      document.body.classList.add("cart-open", "drawer-open", "js-drawer-open", "overflow-hidden");
      return true;
    }

    /* 1) merchant-specified selector (drawer element OR its toggle button) */
    var custom = form && form.getAttribute("data-drawer");
    if (custom) {
      var c = document.querySelector(custom);
      if (c) {
        if (c.tagName === "BUTTON" || c.hasAttribute("data-cart-toggle")) { c.click(); return true; }
        if (tryOpen(c)) return true;
      }
    }
    /* 2) common cart-drawer elements */
    var drawer = document.querySelector(
      "cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, .drawer--cart, [data-cart-drawer]"
    );
    if (drawer && tryOpen(drawer)) return true;
    /* 3) safe toggle buttons only (never an <a href> that would navigate) */
    var tBtn = document.querySelector(
      'button[aria-controls*="cart" i], button[data-cart-drawer-toggle], button.js-cart-trigger, [data-action="open-cart-drawer"]'
    );
    if (tBtn) { tBtn.click(); return true; }
    return false;
  }

  function showCartToast(item) {
    var t = document.querySelector(".hlp-toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "hlp-toast";
      document.body.appendChild(t);
    }
    var title = (item && (item.product_title || item.title)) || "Item";
    t.innerHTML =
      '<span class="hlp-toast__check">&#10003;</span><span>Added to cart — <strong>' +
      title.replace(/</g, "&lt;") +
      '</strong></span><a class="hlp-toast__link" href="' + rootUrl() + 'cart">View cart</a>';
    requestAnimationFrame(function () { t.classList.add("is-visible"); });
    clearTimeout(t.__hideTimer);
    t.__hideTimer = setTimeout(function () { t.classList.remove("is-visible"); }, 4500);
  }

  /* ---- Announcement: pin to very top ---- */
  function initPin() {
    document.querySelectorAll(".hlp-ann[data-hlp-pin-top]").forEach(function (ann) {
      if (ann.__hlpPinned) return; ann.__hlpPinned = true;
      var node = ann.closest(".shopify-section") || ann.closest(".hlp") || ann;
      if (document.body.firstElementChild !== node) document.body.insertBefore(node, document.body.firstChild);
    });
  }

  /* ---- Announcement marquee: seamless continuous loop ---- */
  function initMarquee() {
    document.querySelectorAll(".hlp-ann__track:not([data-hlp-dup])").forEach(function (track) {
      track.setAttribute("data-hlp-dup", "1");
      var original = track.innerHTML;
      var vp = (track.parentElement && track.parentElement.offsetWidth) || window.innerWidth || 1000;
      var guard = 0;
      while (track.scrollWidth < vp + 300 && guard < 40) { track.innerHTML += original; guard++; }
      track.innerHTML += track.innerHTML;
      track.style.animationDuration = Math.max(14, (track.scrollWidth / 2) / 70) + "s";
    });
  }

  /* ---- Loox: cap reviews shown ---- */
  function initLooxLimit() {
    document.querySelectorAll("[data-loox-limit]").forEach(function (box) {
      if (box.__hlpLoox) return; box.__hlpLoox = true;
      var limit = parseInt(box.getAttribute("data-loox-limit"), 10);
      if (!limit || limit < 1) return;
      var apply = function () {
        var nodes = box.querySelectorAll(".loox-review");
        if (!nodes.length) nodes = box.querySelectorAll('[class*="loox-review"]');
        if (!nodes.length) return;
        nodes.forEach(function (n, i) { n.style.display = i < limit ? "" : "none"; });
      };
      new MutationObserver(apply).observe(box, { childList: true, subtree: true });
      apply();
    });
  }

  function init() { initPin(); initMarquee(); initLooxLimit(); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
  else { init(); }
})();
